export type InsightsTrackingEvent = 'time_range_changed' | 'sub_account_filter_changed' | 'advisor_filter_changed' | 'sort_changed' | 'tab_changed' | 'exported'

export interface InsightsTrackingClient {
  track: (event: InsightsTrackingEvent, details?: Record<string, unknown>) => void
}

export const NoopInsightsTrackingClient: InsightsTrackingClient = {
  track: () => {},
}

export type InsightsScope = 'firm_account' | 'enterprise_toplevel' | 'enterprise_account'

export const INSIGHTS_EVENT_NAMES: Record<InsightsTrackingEvent, string> = {
  time_range_changed: 'Insights Time Range Changed',
  sub_account_filter_changed: 'Insights Advisor Filter Changed',
  advisor_filter_changed: 'Insights Advisor Filter Changed',
  sort_changed: 'Insights Sort Changed',
  tab_changed: 'Insights Tab Changed',
  exported: 'Insights Exported',
}

export type InsightsEventSink = (event: { eventName: string; eventDetails: Record<string, unknown> }) => void

export const createInsightsTrackingClient = (sink: InsightsEventSink, scope: InsightsScope): InsightsTrackingClient => ({
  track: (event, details) => sink({ eventName: INSIGHTS_EVENT_NAMES[event], eventDetails: { ...(details ?? {}), scope } }),
})
